define('v3/Common/Components/Dropdown/Dropdown.Component',[
	'jquery',
	'knockout',
	'lodash',
	'text!v3/Common/Components/Dropdown/Dropdown.Component.html',
	'v3/Common/Bindings/Select.Binding'
], function ($, ko, _, htmlString) {
	function validateParams (params) {
		if (!params.options) {
			throw new Error('params.options is expected.');
		}
		if (!_.isArray(params.options) && !ko.isObservable(params.options)) {
			throw new Error('params.options is not an array or observableArray.');
		}
	}

	function DropdownViewModel (params) {
		var self = this;
		var id = _.uniqueId();
		var event;
		validateParams(params);

		self.options = params.options;
		self.value = params.value;
		self.optionsText = params.optionsText;
		self.optionsValue = params.optionsValue;
		self.optionsCaption = params.optionsCaption;
		self.selectedOptions = params.selectedOptions;
		self.select2Options = params.select2Options || {};
		self.enable = params.enable || true;
		self.valueAllowUnset = params.valueAllowUnset || false;
		self.select2Options.minimumResultsForSearch = params.minimumResultsForSearch || Infinity;
		self.select2Options.multiple = params.multiple || false;

		if (params.placeholder) { self.select2Options.placeholder = params.placeholder; }

		self.optionsAfterRender = function (option, item) {
			$(option).data('item', item);

			if (item && item.optionGroup) {
				var $group = $(option).parent().find('optgroup[label="' + item.optionGroup + '"]');
				if (!$group.length) {
					$group = $('<optgroup></optgroup>').attr('label', item.optionGroup).appendTo($(option).parent());
				}

				$(option).appendTo($group);

				if (item.collapsable) {
					$group.attr('collapse', true).attr('title', 'collapse');

					event = $(option)
						.parents('dropdown')
						.parent()
						.off('click.select2__groups_' + id)
						.on('click.select2__groups_' + id, '.select2-results__option[title="collapse"] > .select2-results__group', function () {
							$(this).toggleClass('collapsed');
						});
				}
			}
			if (item) {
				ko.applyBindingsToNode(option, { disable: item.disable }, item);
			}
		};

		if (params.extraClass) {
			self.select2Options.theme = 'default ' + params.extraClass;
		}

		if (params.template) {
			self.select2Options.template = params.template;
		}

		if (params.templateSelection) {
			self.select2Options.templateSelection = params.templateSelection;
		}

		if (params.disabled) {
			self.select2Options.disabled = params.disabled;
		}

		self.dispose = function () {
			if (event) {
				$(document).off(event);
			}
		};
	}

	return { viewModel: DropdownViewModel, template: htmlString };
});
